export default "__VITE_ASSET__W14VxqMQ__"